import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ elementType, elementId, documentId }) =>
    present(
      repository
        .removeAttachedDocument(elementType, elementId, documentId)
        .then(() => ({ elementType, elementId, documentId }))
        .catch(() => Promise.reject({ elementType, elementId, documentId })),
    );
}

export type { Interactor };

export { createInteractor };
